const routers = [
    {
        path: '/task_hall',
        name: 'task_hall',
        meta: {
            exp: '任务大厅',
            requireAuth: false
        },
        component: () => import('@/views/task_hall/index.vue'),
    },
    {
        path: '/task_hall_detail',
        name: 'task_hall_detail',
        meta: {
            exp: '任务详情',
            requireAuth: false
        },
        component: () => import('@/views/task_hall/task_hall_detail/index.vue'),
    },
    {
        path: '/task_hall_enroll',
        name: 'task_hall_enroll',
        meta: {
            exp: '报名投稿',
            requireAuth: false
        },
        component: () => import('@/views/task_hall/task_hall_enroll/index.vue'),
    },
    {
        path: '/task_hall_opus_detail',
        name: 'task_hall_opus_detail',
        meta: {
            exp: '作品详情',
            requireAuth: false
        },
        component: () => import('@/views/task_hall/opus_detail/index.vue'),
    },
    {
        path: '/task_hall_opus_list',
        name: 'task_hall_opus_list',
        meta: {
            exp: '作品列表',
            requireAuth: false
        },
        component: () => import('@/views/task_hall/opus_list/index.vue'),
    },
]
export default routers